import {
  ApiGetRequest,
  ApiPutRequest,
  ApiPostRequest,
  ApiBlobGetRequest,
  // ApiDeleteRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Daftar Pembayaran Hutang',
    title_giro: 'Giro Keluar',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Daftar Hutang',
        href: '/adm/fin/penjualan/hutang-usaha',
        active: true,
      },
    ],
    breadcrumb_giro: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Daftar Giro Keluar',
        href: '/adm/fin/kas-bank/giro-keluar',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_supplier',
    sortDesc: true,
    fields: [
      {
        key: 'code_pay',
        label: 'Kode',
      },
      {
        key: 'tgl_bayar',
        label: 'Tanggal',
      },
      {
        key: 'supplier',
        label: 'Supplier',
      },
      {
        key: 'memo',
        label: 'Keterangan',
      },
      {
        key: 'total_pembayaran',
        label: 'Nilai',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_giro: [
      {
        key: 'tgl_bayar',
        label: 'Tanggal',
      },
      {
        key: 'giro_bank',
        label: 'Nama Bank',
      },
      {
        key: 'giro_no',
        label: 'No Cek',
      },
      {
        key: 'giro_due_date',
        label: 'Jatuh Tempo',
      },
      {
        key: 'supplier',
        label: 'Dari',
      },
      {
        key: 'code_pay',
        label: 'No Ref',
      },
      {
        key: 'total_pembayaran',
        label: 'Nilai',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_invoice: [
      {
        key: 'code_invoice',
        label: 'Kode',
      },
      {
        key: 'tgl_invoice',
        label: 'Tanggal',
      },
      {
        key: 'inv_type',
        label: 'Tipe',
      },
      {
        key: 'term_payment',
        label: 'Term Payment',
      },
      {
        key: 'total_hutang',
        label: 'Total Hutang',
      },
    ],
    id_supplier: false,
    form: {
      acc_cash: '',
      acc_cash_code: '',
      acc_cash_name: '',
      id_supplier: '',
      supplier_name: '',
      tgl_bayar: '',
      id_department: '',
      use_giro: '',
      memo: '',
      acc_denda: '',
      denda: '',
      total_pembayaran: '',
      items: [
        {
          id_bayar_hutang: '',
          item_invoice: '',
          inv_type: '',
          item_acc_disc: '',
          item_disc: '',
          item_acc_bayar: '',
          item_bayar: '',
        },
      ],
    },
    journal: false,
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  journal(state) {
    return state.data.journal;
  },
};

export const mutations = {
  changeBayarHutang(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async pencairanGiroHutang({ commit, dispatch }, payload = null) {
    commit('changeBayarHutang', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `fin/pembayaran-hutang/${payload.id}/pencairan-giro`
    );

    commit('changeBayarHutang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async getListInvoice({ commit, state }) {
    commit('changeBayarHutang', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_supplier: data.form ? data.form.id_supplier : '',
      id_currency: data.id_currency || '',
    };

    let result = await ApiGetRequest(`fin/pembayaran-hutang/invoice`, params);
    commit('changeBayarHutang', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getJournal({ commit }, payload = null) {
    commit('changeBayarHutang', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `fin/pembayaran-hutang/${payload.id}/journal`
    );
    commit('changeBayarHutang', {
      loading: false,
    });

    if (!result.error) {
      commit('changeBayarHutang', {
        journal: result.data.object,
      });
    }

    return !result.error ? true : false;
  },

  async getListBayarHutang({ commit, state }, payload = {}) {
    commit('changeBayarHutang', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      use_giro: data.use_giro ? 1 : 0,
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`fin/pembayaran-hutang`, params);
      commit('changeBayarHutang', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_bayar_hutang.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`fin/pembayaran-hutang`, params);
      commit('changeBayarHutang', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailBayarHutang({ commit, state }, payload = null) {
    commit('changeBayarHutang', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/pembayaran-hutang/${payload.id}`);
    commit('changeBayarHutang', {
      detail: !result.error ? result.data.object : {},
      form: {
        ...data.form,
        ...result.data.object,
        tgl_bayar: result.data.object.tgl_bayar
          ? moment(result.data.object.tgl_bayar).format('DD/MM/YYYY')
          : moment().format('DD/MM/YYYY'),
        doc_date: result.data.object.doc_date
          ? moment(result.data.object.doc_date).format('DD/MM/YYYY')
          : '',
      },
      loading: false,
    });

    return !result.error ? true : false;
  },

  async createBayarHutang({ commit, state, dispatch }) {
    commit('changeBayarHutang', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('fin/pembayaran-hutang', data.form);
    commit('changeBayarHutang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateBayarHutang({ commit, state, dispatch }, payload = null) {
    commit('changeBayarHutang', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `fin/pembayaran-hutang/${payload.id}`,
      data.form
    );

    commit('changeBayarHutang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },
};
